import { Component, OnInit, OnDestroy } from '@angular/core';
import {ExplorerItem, TreeNodeInfo} from "@catui/types";
import {ProjectService} from "@catcore/services";
import {Router} from "@angular/router";
import {isNullOrUndefined} from "util";
import {Project} from "@catcore/types/api-v2";
import {GgwService} from "@catdetails/services/ggw.service";

@Component({
  selector: 'cat-ggw',
  templateUrl: './ggw.component.html',
  styleUrls: ['./ggw.component.scss']
})
export class GgwComponent implements OnInit, OnDestroy {
  doAllowCreate = false;
  activeItem = false;
  explorerItems: ExplorerItem[] = [];
  subscription = null;

  constructor(private projectService: ProjectService,
              private router: Router,
              private ggwService: GgwService) {
  }

  navigateTo(node: TreeNodeInfo) {
    this.router.navigate(node.item.value.route);
  }

  ngOnInit() {
    this.subscription = this.projectService
      .getCurrentProject()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.explorerItems = [];
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Zone Assignment', 'ggw-device-zone-assignments'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Access Profiles', 'ggw-access-profiles'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Device Access', 'ggw-device-access'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Fixed Routes', 'ggw-fixed-routes'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Dynamic Routes', 'ggw-dynamic-routes'));
          this.explorerItems.push(buildDefaultExplorerItem(project, 'Dynamic Route Templates', 'ggw-dynamic-route-templates'));
        }
      });
    this.ggwService.setActive();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.ggwService.setInactive();
  }
}

const buildDefaultExplorerItem = (project: Project, displayName: string, targetRef: string): ExplorerItem => {
  return {label: displayName, value: {route: ['projects', `${project.id}`, 'ggw', targetRef]}, expanded: false, allowedActions: []};
};




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/components/ggw/ggw.component.ts